import React, { ReactNode } from 'react';
import cn from 'classnames';

import { Icons } from '@icons/icons';
import { TIconType } from '@icons/interface';

import DynamicIconWrapper from '../DynamicIconWrapper';

import styles from './TabIconSection.module.scss';

export type TIconTab = {
	value: string;
	icon: TIconType;
	activeIcon: TIconType;
};

interface ITabIconSectionProps {
	currentTab?: string;
	setCurrentTab: React.Dispatch<React.SetStateAction<any>>;
	getCurrentTab: () => React.ReactNode;
	exportHandler?: () => void;
	tabs: TIconTab[];
	maxWidth?: string;
	tabWidth?: string;
	children?: ReactNode;
	isWithoutShadow?: boolean;
	isFullHeight?: boolean;
	isFullWidthTabs?: boolean;
}

const TabIconSection = ({
	currentTab,
	setCurrentTab,
	getCurrentTab,
	tabs,
	maxWidth = '1176px',
	children,
	tabWidth,
	isFullHeight = true,
	isFullWidthTabs,
	exportHandler,
}: ITabIconSectionProps) => {
	const onChangeTab = (tab: string) => () => setCurrentTab(tab);

	return (
		<div
			className={cn(
				styles.whiteWrapper,
				styles.mainSection,
				{
					[styles.fullHeight]: isFullHeight,
				},
			)}
			style={{ maxWidth }}
		>
			<div className={styles.headerWrapper}>
				{exportHandler && (
					<DynamicIconWrapper
						icon={Icons.export}
						onClick={exportHandler}
						tooltipLabel='Export'
					/>
				)}
				<div className={styles.tabsContainer}>
					{
						tabs.map((tab, i) => {
							const isActiveTab = currentTab === tab.value;
							const tabClasses = cn(styles.tab, {
								[styles.selected]: isActiveTab,
								[styles.fullWidth]: isFullWidthTabs,
							});

							return (
								<div
									key={`${tab.value}-${i}`}
									className={tabClasses}
									onClick={onChangeTab(tab.value)}
									style={{ width: tabWidth }}
								>
									{tab?.icon
										&& (
											<div className={cn(styles.iconTab, {
												[styles.activeIconTab]: isActiveTab,
											})}>
												{isActiveTab ? tab.activeIcon() : tab.icon()}
											</div>
										)
									}
								</div>
							);
						})
					}
					{children}
				</div>
			</div>
			<div className={styles.body}>
				{getCurrentTab()}
			</div>
		</div>
	);
};

export default TabIconSection;
